import { useResolveColorTheme } from '@utils/useResolveColorTheme';
import styled from 'styled-components';

const bgLinearLight =
  // eslint-disable-next-line max-len
  'linear-gradient(167.34deg,#00dead -3.96%,rgba(40, 134, 176, 0.516258) 53.57%,rgba(255, 92, 118, 0.6) 114.98%), linear-gradient(0deg, #5329b4, #5329b4)';

const bgLinearDark = 'linear-gradient(180deg, #2D2E34 0%, #2D2E34 100%)';

export const Container = styled.header`
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  height: 4rem;
  padding: 1rem;
  background: ${() =>
    useResolveColorTheme({ light: bgLinearLight, dark: bgLinearDark })};

  > button {
    background: transparent;
    border: 0;
  }

  span {
  font-family: 'Montserrat', sans-serif;
  font-weight: 600!important;
  font-size: 24px;
  color: white
  }

  svg {
    width: 2rem;
    height: 2rem;
  }

`;

export const OverLay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: ${() => useResolveColorTheme({ light: '#fff', dark: '#000' })};
  opacity: 0.6;
  z-index: 9;
`;
